export default "__VITE_ASSET__CurD9EXQ__"